<ng-container *ngIf="trackingState$ | async as trackingState">
  <div class="container">
    <div class="tracking">
      <div class="d-flex align-items-center justify-content-center">
        <ng-container *ngIf="trackingState.loading; else resultTemplate">
          <div class="tracking-card">
            <div class="tracking-card-header">
              <div class="tracking-card-header-payment-status"><span class="skeleton"></span></div>
              <h1>Заказ</h1>
              <p class="tracking-card-header-planned-date">
                Дата готовности заказа:
                <span class="skeleton"></span>
              </p>
              <p class="tracking-card-header-location">
                <svg xmlns="http://www.w3.org/2000/svg" width="11" height="14" viewBox="0 0 11 14" fill="none">
                  <path
                    d="M9.6408 5.3204C9.6408 2.93431 7.70649 1 5.3204 1C2.93431 1 1 2.93431 1 5.3204"
                    stroke="currentColor"
                  />
                  <path
                    d="M1 5.32715C1.12706 9.42746 5.26015 12.5362 5.26015 12.5362C5.26015 12.5362 9.64468 9.39189 9.64468 5.32715"
                    stroke="currentColor"
                    stroke-linecap="round"
                  />
                  <path
                    d="M6.32554 3.21544C6.0212 3.06987 5.68038 2.98836 5.32051 2.98836C4.03259 2.98836 2.98853 4.03242 2.98853 5.32034C2.98853 6.60826 4.03259 7.65233 5.32051 7.65233C6.60843 7.65233 7.6525 6.60826 7.6525 5.32034C7.6525 4.97787 7.57867 4.65264 7.44607 4.3597"
                    stroke="currentColor"
                    stroke-linecap="round"
                  />
                </svg>
                <span class="skeleton"></span>
              </p>
              <p class="tracking-card-header-working-time">
                <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 11 11" fill="none">
                  <circle cx="5.07692" cy="5.07692" r="4.57692" stroke="currentColor" />
                  <path d="M5.07715 2.15417L5.07715 5.84648" stroke="currentColor" stroke-linecap="round" />
                  <path d="M7.07568 7.00031L5.07716 5.84646" stroke="currentColor" stroke-linecap="round" />
                </svg>

                <span class="skeleton"></span>
              </p>
            </div>
            <div class="tracking-card-body">
              <ul class="tracking-statuses">
                <ng-container *ngFor="let i of [].constructor(3)">
                  <li>
                    <span class="skeleton"></span>
                  </li>
                </ng-container>
              </ul>
            </div>
          </div>
        </ng-container>

        <ng-template #resultTemplate>
          <ng-container *ngIf="trackingState.success && trackingState.value; else errorTemplate">
            <ng-container *ngIf="trackingState.value as tracking">
              <div class="tracking-card">
                <div class="tracking-card-header">
                  <div class="tracking-card-header-payment-status">
                    {{ tracking.paymentStatus?.name || 'Ожидает оплаты' }}
                  </div>
                  <h1>Заказ № {{ tracking.orderCode }}</h1>
                  <p
                    class="tracking-card-header-location"
                    *ngIf="tracking.posAddress && tracking.posAddress.formattedAddress; else errorAdressTemplate"
                  >
                    <cx-icon class="tracking-card-header-location-icon" type="LOCATION"></cx-icon>
                    {{ tracking.posAddress.formattedAddress }}
                  </p>
                  <ng-template #errorAdressTemplate>
                    <p *ngIf="showCallMessage$ | async" class="tracking-card-header-location-error">
                      Позвоним для уточнения
                    </p>
                  </ng-template>
                  <p class="tracking-card-header-working-time" *ngIf="tracking.posFormattedWorkingTime">
                    <cx-icon class="tracking-card-header-location-icon" type="WORK_TIME"></cx-icon>

                    {{ tracking.posFormattedWorkingTime }}
                  </p>
                </div>
                <div class="tracking-card-body">
                  <ul class="tracking-statuses">
                    <ng-container *ngFor="let status of tracking.statuses; let i = index">
                      <li
                        [ngClass]="{
                          finished: !!status.formattedDateTime,
                          'final-successful': status.finalStatusSuccessful,
                          'final-canceled': !status.finalStatusSuccessful && i === tracking.statuses.length - 1,
                          'with-date': !!status.formattedDateTime,
                        }"
                      >
                        {{ status.name }}
                      </li>
                      <div class="date-at" *ngIf="status.formattedDateTime">
                        {{ status.formattedDateTime }}
                      </div>
                    </ng-container>
                  </ul>
                </div>
              </div>
            </ng-container>
          </ng-container>
        </ng-template>

        <ng-template #errorTemplate>
          <div class="error">
            <h1>Информация о доставке не найдена</h1>
            <p>Обратитесь в колл-центр</p>
            <a href="tel:88003337719" class="btn">8 800 333 77 19</a>
          </div>
        </ng-template>
      </div>

      <div class="buttons">
        <button
          *ngIf="trackingState.value?.scheme as scheme"
          sdButton
          (click)="openScheme()"
          [fullWidth]="true"
          type="outlined"
        >
          Схема проезда по складу
        </button>
        <a
          sdButton
          [fullWidth]="true"
          type="accent"
          [routerLink]="{ cxRoute: 'category', params: { code: 'stroitelnye-materialy-5521' } } | cxUrl"
        >
          {{ trackingState.error ? 'В каталог' : 'Купить ещё' }}
        </a>
      </div>
    </div>
  </div>
</ng-container>
